/* ============================================================
   INWARDLY — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky Header ── */
  const header = document.getElementById('site-header');
  if (header && header.classList.contains('site-header--sticky')) {
    const onScroll = () => {
      header.classList.toggle('site-header--scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav ── */
  const mobileNav = document.getElementById('mobile-nav');
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNavClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // Close on backdrop click
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) closeMobileNav();
    });
  }

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCartDrawer();
    }
  });

  /* ── Cart Drawer ── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawerClose = document.querySelector('.cart-drawer__close');
  const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', openCartDrawer));
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  /* ── Cart Count Update ── */
  function updateCartCount(count) {
    const countEl = document.getElementById('cart-count');
    if (!countEl) return;
    countEl.textContent = count;
    countEl.classList.toggle('is-hidden', count === 0);
  }

  /* ── Add to Cart (Product Cards) ── */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      const btnText = btn.querySelector('.btn-text');
      if (btnText) {
        const original = btnText.textContent;
        btnText.textContent = 'Adding...';
        setTimeout(() => { btnText.textContent = original; btn.disabled = false; }, 1200);
      }
    }

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });
      const cart = await response.json();
      if (response.ok) {
        await refreshCart();
        openCartDrawer();
      }
    } catch (err) {
      console.error('Add to cart error:', err);
      if (btn) btn.disabled = false;
    }
  });

  /* ── Add to Cart (Product Page) ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart');
      const btnText = btn?.querySelector('.btn-text');
      const btnLoading = btn?.querySelector('.btn-loading');

      if (btn) {
        btn.disabled = true;
        if (btnText) btnText.classList.add('is-hidden');
        if (btnLoading) btnLoading.classList.remove('is-hidden');
      }

      try {
        const formData = new FormData(productForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        if (response.ok) {
          await refreshCart();
          openCartDrawer();
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        if (btn) {
          btn.disabled = false;
          if (btnText) btnText.classList.remove('is-hidden');
          if (btnLoading) btnLoading.classList.add('is-hidden');
        }
      }
    });
  }

  /* ── Refresh Cart Drawer ── */
  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      updateCartCount(cart.item_count);
      // Refresh cart drawer items via section rendering
      const pageHtml = await (await fetch(window.location.pathname, { cache: 'no-store' })).text(); const freshDoc = new DOMParser().parseFromString(pageHtml, 'text/html'); ['.cart-drawer__items', '.cart-drawer__footer'].forEach((sel) => { const fresh = freshDoc.querySelector('#cart-drawer ' + sel); const current = document.querySelector('#cart-drawer ' + sel); if (fresh && current) current.replaceWith(fresh); });
      // Simplified: just update the count
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }

  /* ── Quantity Selectors ── */
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-qty-decrease]')) {
      const input = e.target.parentElement.querySelector('.quantity-selector__input');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    }
    if (e.target.matches('[data-qty-increase]')) {
      const input = e.target.parentElement.querySelector('.quantity-selector__input');
      if (input) input.value = parseInt(input.value) + 1;
    }
  });

  /* ── Cart Drawer Qty Buttons ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const key = btn.dataset.key;
    const isIncrease = btn.classList.contains('qty-increase');
    const isDecrease = btn.classList.contains('qty-decrease');
    if (!key || (!isIncrease && !isDecrease)) return;

    const qtyValue = btn.closest('.cart-item__qty')?.querySelector('.qty-value');
    const currentQty = parseInt(qtyValue?.textContent || '1');
    const newQty = isIncrease ? currentQty + 1 : Math.max(0, currentQty - 1);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
      });
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);

      if (newQty === 0) {
        btn.closest('.cart-item')?.remove();
      } else if (qtyValue) {
        qtyValue.textContent = newQty;
      }
    } catch (err) {
      console.error('Cart update error:', err);
    }
  });

  /* ── Product Image Gallery ── */
  const thumbs = document.querySelectorAll('.product-media__thumb');
  const mainImage = document.getElementById('main-product-image');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImage) {
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.alt = thumb.dataset.imageAlt || '';
      }
    });
  });

  /* ── Variant Selector ── */
  const variantSelect = document.getElementById('variant-select');
  const priceEl = document.getElementById('product-price');
  const swatches = document.querySelectorAll('.product-option__swatch input');

  function updateVariant() {
    const selected = variantSelect?.options[variantSelect.selectedIndex];
    if (!selected || !priceEl) return;
    const price = parseInt(selected.dataset.price);
    const compare = parseInt(selected.dataset.compare);
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    priceEl.querySelector('.price').textContent = formatter.format(price / 100);
    const compareEl = priceEl.querySelector('.compare-price');
    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatter.format(compare / 100);
        compareEl.classList.remove('is-hidden');
      } else {
        compareEl.classList.add('is-hidden');
      }
    }
  }

  if (swatches.length) {
    swatches.forEach((swatch) => {
      swatch.addEventListener('change', () => {
        // Update selected state
        swatch.closest('.product-option__values')
          ?.querySelectorAll('.product-option__swatch')
          .forEach(s => s.classList.remove('is-selected'));
        swatch.closest('.product-option__swatch')?.classList.add('is-selected');

        // Find matching variant
        const selectedOptions = [];
        document.querySelectorAll('.product-option__values').forEach(group => {
          const selected = group.querySelector('input:checked');
          if (selected) selectedOptions.push(selected.value);
        });

        if (variantSelect) {
          for (const option of variantSelect.options) {
            const title = option.textContent.trim();
            if (selectedOptions.every(opt => title.includes(opt))) {
              variantSelect.value = option.value;
              break;
            }
          }
          updateVariant();
        }
      });
    });
  }

  /* ── Product Tabs ── */
  const tabBtns = document.querySelectorAll('.product-tabs__btn');
  const tabPanels = document.querySelectorAll('.product-tabs__panel');

  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('is-active'));
      tabPanels.forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      document.getElementById(`tab-${target}`)?.classList.add('is-active');
    });
  });

  /* ── Collection Sort ── */
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

})();
